import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-163332ea"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 2,
  style: {
    "color": "red"
  }
};
const _hoisted_4 = {
  key: 3
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_step = _resolveComponent("van-step");
  const _component_van_steps = _resolveComponent("van-steps");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_cell_group, {
    title: "整体进度：",
    border: false,
    inset: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_steps, {
      active: $options.hActive
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.nodeDefinitions, item => {
        return _openBlock(), _createBlock(_component_van_step, {
          key: item.nodeIndex
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    }, 8, ["active"])]),
    _: 1
  }), _createVNode(_component_van_cell_group, {
    title: "详细步骤：",
    border: false,
    inset: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_steps, {
      direction: "vertical",
      active: $options.vActive
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detailNodes, (item, index) => {
        return _openBlock(), _createBlock(_component_van_step, {
          key: index
        }, {
          default: _withCtx(() => [index == $data.detailNodes.length - 1 ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(item.nodeName) + "：" + _toDisplayString(item.userName), 1)) : (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(item.nodeName) + "：" + _toDisplayString(item.userName), 1)), item.status == '3' ? (_openBlock(), _createElementBlock("p", _hoisted_3, "退回原因：" + _toDisplayString(item.remark), 1)) : _createCommentVNode("", true), item.status != '0' ? (_openBlock(), _createElementBlock("p", _hoisted_4, "操作时间：" + _toDisplayString(item.beginTime) + " - " + _toDisplayString(item.finishTime), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    }, 8, ["active"])]),
    _: 1
  })]);
}